import styled from "styled-components";

import { Frame } from "components/ui-kit/styled-templates";

import districts from "constants/districts";

const InteractiveMapEnhanced = (props) => {
    const { onItemClick = () => {} } = props;

    return (
        <Wrapper>
            <Svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="1091.9919" height="630.11902" viewBox="0 0 1091.992 630.119" id="svg2">
                {districts.map((i, index) => (
                    <path
                        key={index}
                        {...i}
                        onClick={() => {
                            onItemClick(i);
                        }}
                    />
                ))}
            </Svg>
        </Wrapper>
    );
};

const Wrapper = styled(Frame)`
    position: relative;
    width: 100%;
    height: 100%;
`;

const Svg = styled.svg`
    path {
        fill: #cccccc;
        fill-opacity: 1;
        stroke: #000000;
        stroke-width: 1;
        stroke-miterlimit: 4;
        stroke-dasharray: none;
        stroke-opacity: 1;

        &:hover {
            filter: drop-shadow(0px 0px 10px ${({ theme }) => theme.blue});
            cursor: pointer;
        }
    }

    width: 100%;
`;

export default InteractiveMapEnhanced;
